/** Import tarixi o'ng tugma menyusi: davom ettirish, manbaga o'tish (test: features/admin/menu.test.ts yonida). */
import { Copy, ExternalLink, Eye } from "lucide-react";
import { compactMenu, SEPARATOR, type MenuEntry } from "@/components/ui/context-menu";
import type { Translate } from "@/features/drivers/menu";
import type { ImportJob } from "./api";

export interface ImportMenuActions {
  open: () => void;
  openUrl: (url: string) => void;
  copy: (text: string) => void;
}

export function importMenu(j: ImportJob, a: ImportMenuActions, t: Translate): MenuEntry[] {
  const sheet = j.source_type === "gsheet" && !!j.sheet_url;
  return compactMenu([
    { key: "open", label: j.status === "done" ? t("import.openResult") : t("import.continue"), icon: Eye, onSelect: a.open },
    SEPARATOR,
    sheet && { key: "open-sheet", label: t("import.openSheet"), icon: ExternalLink, onSelect: () => a.openUrl(j.sheet_url) },
    sheet && { key: "copy-sheet", label: t("import.copySheetLink"), icon: Copy, onSelect: () => a.copy(j.sheet_url) },
  ]);
}
